import { formatDistanceToNow } from "date-fns";
import Icon from "../../../components/AppIcon";
import { RecentActivity } from "../types";

interface RecentActivityFeedProps {
  activities: RecentActivity[];
}

const RecentActivityFeed = ({ activities }: RecentActivityFeedProps) => {
  const getPlatformIcon = (platform: string): string => {
    const iconMap: Record<string, string> = {
      github: "Github",
      linkedin: "Linkedin",
      twitter: "Twitter",
      blog: "BookOpen",
    };
    return iconMap[platform.toLowerCase()] || "Activity";
  };

  const getPlatformColor = (platform: string): string => {
    const colorMap: Record<string, string> = {
      github: "#6e5494",
      linkedin: "#0077b5",
      twitter: "#1da1f2",
      blog: "#ff6b6b",
    };
    return colorMap[platform.toLowerCase()] || "var(--color-primary)";
  };

  const handleActivityClick = (link: string) => {
    window.open(link, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="Activity" size={20} color="var(--color-primary)" />
        <h3 className="text-lg font-semibold text-foreground">Recent Activity</h3>
      </div>

      <div className="space-y-3">
        {activities.map((activity) => (
          <button
            key={activity.id}
            onClick={() => handleActivityClick(activity.link)}
            className="w-full p-4 rounded-lg border border-border bg-surface hover:border-primary/50 transition-all duration-300 hover:shadow-elevation-1 text-left group"
          >
            <div className="flex items-start gap-3">
              <div
                className="p-2 rounded-lg transition-colors duration-300"
                style={{ backgroundColor: `${getPlatformColor(activity.platform)}15` }}
              >
                <Icon
                  name={getPlatformIcon(activity.platform)}
                  size={18}
                  color={getPlatformColor(activity.platform)}
                />
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-sm font-medium text-foreground capitalize">
                    {activity.platform}
                  </span>
                  <span className="text-xs text-muted-foreground">
                    {formatDistanceToNow(activity.timestamp, { addSuffix: true })}
                  </span>
                </div>
                <p className="text-sm text-muted-foreground line-clamp-2 group-hover:text-foreground transition-colors duration-300">
                  {activity.content}
                </p>
              </div>

              <Icon
                name="ExternalLink"
                size={16}
                className="text-muted-foreground group-hover:text-primary transition-colors duration-300 flex-shrink-0"
              />
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default RecentActivityFeed;